import { SourceEnum } from '@yunxi/tim';

export const config = {
  SDKAppID: +(import.meta.env.VITE_APP_TIM_SDKAPPID as string),
  source: SourceEnum.B,
};
